import React, { useState, useEffect, useMemo } from "react";

import {
  Box,
  Grid,
  Button,
  ButtonGroup,
  FormLabel,
  Skeleton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  Fade,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { NavLink, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";

// Context
import { useContext } from "react";
import { UserContext } from "../../Components/Context/Context";
import fondoBlanco from "../../assets/fondoblanco.jpg";
import Expedientes from "../../Expedientes/Expedientes";
import api from "../../api/axios";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

const Ver = () => {
  const navigate = useNavigate();

  const { goPanel, goEdit, goTable } = useLocationHelpers();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("id");
  const [caseControlNumber, setCaseControlNumber] = useState(-1);
  const [flagActiveCases, setFlagActiveCases] = useState(true);

  const [lawyerData, setLawyerData] = useState({
    userEmail: "",
    userName: "",
    userProvince: null, // Cambiado a null para manejar Autocomplete
    userAddress: "",
    userPostalCode: "",
    userNif: "",
    userPhone: "",
  });

  const [companyData, setCompanyData] = useState({});

  const [flag, setFlag] = useState(false);

  const { userData } = useContext(UserContext);

  const ImageCell = () => {
    // const { userData } = useContext(UserContext);
    // Verifica que `asocData.userCompany` y `asocData.userCompany.company_logo` existan antes de usarlos
    const imageUrl =
      companyData?.id && companyData?.company_logo // Verifica que existan `id` y `company_logo`
        ? `${process.env.REACT_APP_BACKEND_HOST}/storage/company/${companyData.id}/${companyData.company_logo}` // Usa la imagen original si está disponible
        : fondoBlanco; // Si no hay imagen, el valor será null

    return (
      <img
        src={imageUrl} // Usa una imagen de reemplazo si `imageUrl` es null
        alt="User logo"
        className="image-views"
      />
    );
  };

  // Obtener los datos del usuario
  const getDataUsers = async () => {
    setFlag(true);

    const url = `${process.env.REACT_APP_API_URL}/showlawyer`;

    try {
      const response = await api.post(url, { id: userId });
      console.log(response);

      const {
        email,
        name,
        province,
        address,
        postalcode,
        nif,
        phone,
        id,
        company_relation,
      } = response.data.lawyer[0];

      setCompanyData(company_relation || {});

      setLawyerData({
        userEmail: email,
        userName: name,
        userProvince: province,
        userAddress: address,
        userPostalCode: postalcode,
        userNif: nif,
        userPhone: phone,
      });
    } catch (error) {
      console.error("Error fetching user data:", error); // Mensaje de error más descriptivo
    } finally {
      setFlag(false); // Asegurarse de desactivar la bandera en caso de error o éxito
    }
  };

  useEffect(() => {
    getDataUsers();
  }, []);

  useEffect(() => {
    console.log(caseControlNumber);
    if (caseControlNumber === 0) {
      setFlagActiveCases(false);
    } else {
      setFlagActiveCases(true);
    }
  }, [caseControlNumber]);

  const labels = {
    userName: "Nombre",
    userEmail: "Correo",
    userProvince: "Provincia",
    userAddress: "Dirección",
    userPostalCode: "Código Postal",
    userNif: "NIF",
    userPhone: "Teléfono",
  };

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Usuarios" subTitle="Ver" />

      {flag ? (
        <LoadingPage heightProp={"40vh"} isLoading />
      ) : (
        <Fade in={!flag} timeout={1000}>
          <div>
            <Box
              component="form"
              sx={{ margin: "auto", "& > :not(style)": {} }}
              noValidate
              autoComplete="off"
              className="formMainContainer">
              <Grid
                container
                style={{ textAlign: "center" }}
                p={2}
                className="fontSize">
                <Grid item xs={12} md={4} className="image-view-container">
                  {ImageCell()}
                </Grid>
                {!flag &&
                  lawyerData &&
                  Object.entries(lawyerData).length > 0 && (
                    <Grid container item xs={12} md={8} textAlign={"left"}>
                      {Object.entries(lawyerData).map(([key, value]) => (
                        <Grid item xs={12} textAlign={"left"} key={key}>
                          <FormLabel>
                            <b>{`${labels[key]}:`}</b> {`${value}`}
                          </FormLabel>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                <Grid item xs={12}>
                  <ButtonGroup
                    sx={{
                      width: "100%",
                      justifyContent: "center",
                      textAlign: "center",
                      margin: "20px auto 0px auto",
                    }}>
                    <Button
                      sx={{ width: "100%" }}
                      onClick={() => goEdit("usuarios", userId, "Usuario")}
                      variant="outlined"
                      color="success">
                      Editar
                    </Button>
                    <Button
                      sx={{ width: "100%" }}
                      onClick={() => goTable("usuarios", "Usuarios")}
                      variant="outlined"
                      color="error">
                      Tabla
                    </Button>
                    {/* <Button
                    sx={{ width: "100%" }}
                    onClick={goPanel}
                    variant="outlined"
                  >
                    Inicio
                  </Button> */}
                  </ButtonGroup>
                </Grid>
              </Grid>
            </Box>
            <Box
              component="form"
              sx={{ margin: "8px", "& > :not(style)": {} }}
              noValidate
              autoComplete="off">
              <Accordion sx={{ padding: "10px" }} defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header">
                  Expedientes
                </AccordionSummary>
                <AccordionDetails>
                  {flagActiveCases === true ? (
                    <Expedientes
                      flagToShow={false}
                      userCase={userId}
                      setCaseControlNumber={setCaseControlNumber}
                    />
                  ) : (
                    <Alert color="info" severity="info">
                      {" "}
                      Sin expedientes asociados...
                    </Alert>
                  )}
                </AccordionDetails>
              </Accordion>
            </Box>
          </div>
        </Fade>
      )}
    </div>
  );
};

export default Ver;
